// const PercentCodeType = {
//   value: "PERCENT",
//   name: "Percent",
// };

const AmountCodeType = {
  value: "AMOUNT",
  name: "Dollar Amount",
};

const FreeShippingCodeType = {
  value: "FREE_SHIPPING",
  name: "Free Shipping",
};

export const PromoCodeEnum = {
  // PERCENT: PercentCodeType,
  AMOUNT: AmountCodeType,
  FREE_SHIPPING: FreeShippingCodeType,
};

export const PromoCodeTypes = [
  // PercentCodeType,
  AmountCodeType,
  FreeShippingCodeType,
];

export const getCodeObjectFromName = (name) => {
  return PromoCodeTypes.find((code) => code.name === name);
};

export const getCodeObjectFromValue = (value) => {
  return PromoCodeTypes.find((code) => code.value === value);
};
